const state = {
    allAirlineDet: null,
    allAirlineRes: null,
}

// getters
const getters = {
    GET_ALL_AIRLINE_DET: (state) => {
        return state.allAirlineDet;
    },
    GET_ALL_AIRLINE_RES: (state) => {
        return state.allAirlineRes;
    },
}

// actions
const actions = {
    CLEAR_C_AIRLINE_STORE: ({ commit }) => {
        commit('clearCAirlineStore');
    },
    SET_ALL_AIRLINE_DET({ commit }, airline) {
        commit('getAllAirlineDet', airline);
    },
    SET_ALL_AIRLINE_RES({ commit }, airlineRes) {
        commit('getAllAirlineRes', airlineRes);
    },
}

// mutations
const mutations = {
    clearCAirlineStore(state) {
        state.allAirlineDet = null;
        state.allAirlineRes = null;
    },
    getAllAirlineDet(state, airline) {
        state.allAirlineDet = airline
    },
    getAllAirlineRes(state, airlineRes) {
        state.allAirlineRes = airlineRes
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

